import React from 'react';
import styled from '@emotion/styled';
import { JiraSoftwareLogo } from '@atlaskit/logo';
import { TABLET_BREAKPOINT, SPACING_UNIT } from '../styled';

export function SimpleSignupNav() {
  return (
    <NavContainer>
      <JiraSoftwareLogo appearance="brand" />
    </NavContainer>
  );
}

const NavContainer = styled.div`
  margin-top: ${SPACING_UNIT * 4}px;
  margin-bottom: ${SPACING_UNIT * 6}px;

  [role='img'] {
    height: 28px;
  }

  @media (min-width: ${TABLET_BREAKPOINT}) {
    margin-top: ${SPACING_UNIT * 5}px;
    margin-bottom: ${SPACING_UNIT * 12}px;

    [role='img'] {
      height: 34px;
    }
  }
`;
